module.exports = __webpack_public_path__ + "images/loader.svg";